import {HTTP} from '@/services/HttpServices';
import {CommunityEventSummary} from '@/community-calendar/CommunityCalendarModel';
import {CancelToken} from 'axios';

export function getCommunityEventSummaries(params: { searchText?: string, startDate?: string, endDate?: string }, cancelToken?: CancelToken): Promise<CommunityEventSummary[]> {
    let query = [];
    if (params.searchText) {
        query.push('searchText=' + params.searchText);
    }
    if (params.startDate) {
        query.push('startDate=' + params.startDate);
    }
    if (params.endDate) {
        query.push('endDate=' + params.endDate);
    }
    return HTTP.get(`/public/community-calendar/?${query.join('&')}`, cancelToken);
}